// Set this to true to enable waitlist mode
export const WAITLIST = process.env.NEXT_PUBLIC_WAITLIST_ENABLED === "true"; 